export const MAPPING_READ_INIT = 'MAPPING_READ_INIT'
export const MAPPING_READ_SAVE = 'MAPPING_READ_SAVE'
export const MAPPING_READ_UPDATE = 'MAPPING_READ_UPDATE'
export const MAPPING_READ_SELECT_TAB = 'MAPPING_READ_SELECT_TAB'
